export const USE_CASE_TYPES = {
  general: 'general',
  structuredTag: 'structuredTag',
  freeForm: 'freeForm',
  actionButton: 'actionButton',
  statusTag: 'statusTag',
  filters: 'filters',
};
